const moderatorReviewStatuses = {
  'auto-published': {
    label: 'Auto Published',
    borderStyles: 'border-0 rounded-l-5',
    scope: 'autopublished',
  },
  'needs-review': {
    label: 'Needs Review',
    borderStyles: 'border-l',
    scope: 'for_review',
  },
  approved: {
    label: 'Approved & Published',
    borderStyles: 'border-l',
    scope: 'approved',
  },
  rejected: {
    label: 'Rejected',
    borderStyles: 'border-l rounded-r-5',
    scope: 'rejected',
  },
};

export default moderatorReviewStatuses;
